<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container" v-if="$auth.check()">
      <div class="row">
        <div class="col-lg-12">
          <logo-header></logo-header>
        </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card">
            <div class="card-body">
              <div class="p-2">
                <div class="text-center">
                  <div class="avatar-md mx-auto">
                    <div class="avatar-title rounded-circle bg-light">
                      <i class="bx h1 mb-0 text-primary" :class="{
                        'text-primary bxs-envelope': !showError,
                        'text-danger bxs-error-circle' : showError
                      }"></i>
                    </div>
                  </div>
                  <div class="p-2 mt-4">
                    <div v-if="!showError">
                      <h4>{{ $t('pages.email_verification.verify_message') }}</h4>
                      <p class="mt-3 mb-2" v-html="$t('pages.email_verification.email_message', { email : $auth.user().email })">
                      </p>

                      <div class="mt-3">
                        <span class="mt-5">{{ $t('pages.email_verification.didnt_receive') }}</span>
                        <br>
                        <b-btn @click="resend" class="btn btn-success w-md mt-2"
                               :disabled="disabledResend"
                        >
                          <b-spinner v-if="loading" small></b-spinner>
                          <i class="mdi mdi-arrow-right-circle me-1" v-else></i>
                          {{ $t('pages.email_verification.resend') }}
                        </b-btn>
                        <div class="text-danger mt-1" v-if="disabledResend">
                          <p class="font-size-12"
                             v-html="$t('pages.email_verification.time_left', {seconds : counter})"></p>
                        </div>
                      </div>

                    </div>

                    <div v-else>
                      <h4>{{ $t('pages.email_verification.error_title') }}</h4>
                      <p>
                        {{ $t('pages.email_verification.error_info') }}
                      </p>

                      <div>
                        <b-btn href="mailto:info@sellerdesk.ai" variant="link">
                          {{ $t('pages.email_verification.contact') }}
                        </b-btn>
                      </div>

                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
          <login-footer></login-footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginFooter from "./components/LoginFooter";
import LogoHeader from "../../../components/LogoHeader";
import AuthService from "../../../Services/Api/AuthService";

/**
 * Email verification component
 */
export default {
  name: "EmailVerification",
  page() {
    return {
      title: this.$t('pages.email_verification.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  components: {LogoHeader, LoginFooter},
  data() {
    return {
      loading: false,
      disabledResend: false,
      showError: false,
      counter: 120,
      intervalId: null
    };
  },
  methods: {
    timer() {
      if (this.counter > 1) {
        this.counter -= 1
      } else {
        clearInterval(this.intervalId)
        this.counter = 120
        this.disabledResend = false
      }
    },
    async resend() {
      this.loading = true
      this.disabledResend = true
      await AuthService.resendVerificationEmail().then(() => {
        this.loading = false
        this.disabledResend = true
      }).catch(() => {
        this.showError = true
      }).finally(() => {
        this.loading = false
        this.intervalId = setInterval(this.timer, 1000)
      })
    }
  },
};
</script>